export default __webpack_public_path__ + "static/Otter-33106f86b128a8837c1deb48be101772.gif";